
//
const custodialServiceButtons = document.querySelectorAll('.service-button[data-service="depositguard-custodial-personal"], .service-button[data-service="depositguard-custodial-company"]');

if (custodialServiceButtons !== undefined && custodialServiceButtons.length > 0) {

    //
    const createElement = require('../utils/createElement.js');

    //
    for (const custodialServiceButton of custodialServiceButtons) {

        //
        const serviceName = custodialServiceButton.dataset.service;

        //
        const requestServiceToken = function(callback) {
            const promise = fetch(((serviceName == 'depositguard-custodial-personal') ? '/api/get-depositguard-custodial-personal-service-token' : '/api/get-depositguard-custodial-company-service-token'), {'method' : 'POST'});
            promise.then((response) => response.json()).then((response) => {
                callback(response);
            }).catch((error) => {

                        //no token - now what?

                console.error(error);



            });
        }

        //if this is the first time using the service, you must agree that you are using the service for your own properties
        if (custodialServiceButton.querySelector('input[name="understand-only-own-manage"]') !== null) {
            custodialServiceButton.querySelector('input[name="understand-only-own-manage"]').addEventListener('change', function(event) {
                custodialServiceButton.querySelector('button[data-action="get-depositguard-custodial-service-token"]').disabled = !event.target.checked;
            });
        }

        //toggle the information panel as needed
        custodialServiceButton.addEventListener('click', function(event) {
            if (event.target.matches('[data-action="toggle-service-information"]') == true) {
                event.target.closest('.service-button').setAttribute('data-show-service-information', ((custodialServiceButton.dataset.showServiceInformation == 'no') ? 'yes' : 'no'));
            }
        });

        //
        custodialServiceButton.querySelector('button[data-action="get-depositguard-custodial-service-token"]')?.addEventListener('click', function(event) {

            //
            if (event.target.disabled == true) {
                return false;
            }

            //
            event.preventDefault(); event.stopPropagation();

            //
            event.target.disabled = true;

            //
            requestServiceToken(function(response) {

                const serviceButtonForm = custodialServiceButton.querySelector('.service-button-button');

                //
                serviceButtonForm.append(createElement('input', { 'type': 'hidden', 'name' : 'nrla_guid',      'value' : response.details.serviceToken }));
                serviceButtonForm.append(createElement('input', { 'type': 'hidden', 'name' : 'auth_token',     'value' : response.details.token        }));
                serviceButtonForm.append(createElement('input', { 'type': 'hidden', 'name' : 'expiry_time',    'value' : response.details.expiry       }));

                //
                serviceButtonForm.submit();

            });

        });

    }

}